import { createRouter, createWebHistory } from 'vue-router'
import Layout from '@/layout'

const routes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        component: () => import('@/views/index/index'),
        name: 'Home',
        meta: { title: '认证业务', icon: 'dashboard', affix: true }
      }
    ]
  },
  {
    path: '/nav',
    component: Layout,
    children: [
      {
        path: 'list/:nid(\\d+)',
        component: () => import('@/views/nav/list'),
        name: 'NavList'
      },
    ]
  },
  {
    path: '/article',
    component: Layout,
    children: [
      {
        path: 'detail/:aid(\\d+)',
        component: () => import('@/views/article/detail'),
        name: 'ArticleDetail'
      },
      {
        path: 'list/:nid(\\d+)',
        component: () => import('@/views/article/list'),
        name: 'ArticleList'
      }
    ]
  },
  {
    path: '/certPro',
    component: Layout,
    children: [
      {
        path: 'detail/:aid(\\d+)',
        component: () => import('@/views/cert_product/detail'),
        name: 'CertProDetail'
      },
    ]
  },
/*  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/About.vue')
  }*/
]



const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
